<template>
  <div class="about">
    <h4>Über diese Webseite</h4>
    <p>
      MapDrop &ndash; alpha v{{ gitLastTag }}-{{ gitCommitsSinceLastTag }}-g{{ gitCommitAbbrSha }} ({{ gitBuildTime }})<br>
      Ein Geografie-Lernspiel (Neudeutsch "Edu-Game")
    </p>
    <p>
      Feedback gerne an Hennes unter
      <a href="mailto:info@mapdrop.de?subject=MapDrop%20v0.1.2%20|%20Feedback">
        info@mapdrop.de
      </a>
    </p>
    <h4>Entwicklung</h4>
    <p>
      Ich baue und betreibe diese Webseite in meiner Freizeit. Sie ist aus einer
      alten Idee und dem Zeitvertreib mit Google Earth entstanden und ist das
      fehlende, simple Spiel, das ich im Netz nie fand. Ganz nebenbei ist sie
      meine technische Spielwiese und ein Lernprojekt. Ergo übernehme ich keine
      Garantie für ihre Verfügbarkeit, Fehlerfreiheit oder die Sinnhaftigkeit
      der einen oder anderen Funktion.
    </p>
    <p>
      <router-link to="/feedback">Feedback</router-link> jeglicher, konstruktiver Art ist sehr willkommen. Email-Link siehe oben.
    </p>
    <p>
      <u>Ideen für zukünftige Features sind (in gewürfelter Reihenfolge):</u><br>
      Karten-Themes, ansprechendes Design, sinniges Layout, verschiedene
      Entdecker-Spielmodi für geografisch besonders interessante Gebiete,
      Beschränkung auf Länder oder Regionen, Mehrspielermodus, spaßige Punktevergabe,
      persönliche Highscore
    </p>
    <h4>Impressum</h4>
    <p>
      Hennes Brütt<br>
      Geseker Str. 10<br>
      33154 Salzkotten
    </p>
    <p>
      E-Mail: hennzen at gmail punkt com
    </p>
    <p><router-link to="/privacy">Datenschutz</router-link></p>
    <h4>Und sonst...</h4>
    <p>
      Erstellt mit <a href="https://vuejs.org/">Vue.js</a> und
      <a href="https://leafletjs.com">Leaflet.js</a><br>
      Satellitenbilder von <a href="https://www.esri.com">ESRI</a><br>
      Gehostet auf <a href="https://www.netlify.com/">Netlify</a><br>
      Domain bei <a href="https://www.goneo.de/">Goneo</a><br><br>
      Gebaut mit ❤️, etwas ☕ und Rosinenbrötchen im
      <a href="https://feelgood-workspace.com/">Feelgood Workspace</a> in
      Paderborn
    </p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      gitLastTag: process.env.GIT_LAST_TAG,
      gitCommitAbbrSha: process.env.GIT_COMMIT_ABBR_SHA,
      gitCommitsSinceLastTag: process.env.GIT_COMMITS_SINCE_LAST_TAG,
      gitBuildTime: process.env.GIT_BUILD_TIME
    }
  }
}
</script>

<style lang="postcss">
.about {
  padding: 1.5rem;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6em;
}
</style>
